import { AxiosInstance } from 'axios';
import * as Auth from '@estendio/presentpal-auth';
import { IAwsClient } from '@estendio/presentpal-auth';
import { IAwsDeck } from '@estendio/presentpal-auth/dist/cloudDeckStorage/types';

export interface IDeckStorageClient extends IAwsClient {
  saveDeck(deck: IAwsDeck): Promise<IAwsDeck>;
}

// The fields of CloudDeckStorageClient that saveDeck needs, which the class
// declares private
interface ClientInternals {
  myClient: AxiosInstance;
  myCredentials: { id: string };
}

// presentpal-auth's updateDeck can't tell the caller what was saved: it's
// debounced, so it resolves with an earlier call's result, and it reads
// response.result where axios puts the body in response.data. saveDeck sends
// one deck straight away and resolves with the saved deck, so the server's
// modified can be recorded. DeckRepository does the debouncing (EST-1835)
export class DeckStorageClient
  extends Auth.CloudDeckStorageClient
  implements IDeckStorageClient
{
  async saveDeck(deck: IAwsDeck): Promise<IAwsDeck> {
    const { myClient, myCredentials } = this as unknown as ClientInternals;
    const data = JSON.stringify({
      deleted: !!deck.deleted,
      name: deck.name,
      slides: deck.slides,
      presentationsStarted: deck.presentationsStarted,
      presentationsCompleted: deck.presentationsCompleted,
      rehearsalsStarted: deck.rehearsalsStarted,
      rehearsalsCompleted: deck.rehearsalsCompleted,
      presentationDate: deck.presentationDate,
    });

    const response = await myClient.put<{ result: IAwsDeck }>(
      `/accounts/${myCredentials.id}/decks/${deck.id}`,
      data,
    );

    return response.data.result;
  }
}
